import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  SITE_ANNOUNCEMENTS_FEATURE_KEY,
  SiteAnnouncementsState,
  siteAnnouncementsAdapter,
} from './site-announcements.reducer'

export const selectSiteAnnouncementsState =
  createFeatureSelector<SiteAnnouncementsState>(SITE_ANNOUNCEMENTS_FEATURE_KEY)

const { selectAll, selectEntities } = siteAnnouncementsAdapter.getSelectors()

export const selectSiteAnnouncementsLoaded = createSelector(
  selectSiteAnnouncementsState,
  (state: SiteAnnouncementsState) => state.loaded,
)

export const selectAllSiteAnnouncements = createSelector(
  selectSiteAnnouncementsState,
  (state: SiteAnnouncementsState) => selectAll(state),
)

export const selectDisplayedSiteAnnouncements = createSelector(
  selectSiteAnnouncementsState,
  (state: SiteAnnouncementsState) => selectAll(state).filter((announcement) => announcement.display),
)

export const selectSiteAnnouncementsEntities = createSelector(
  selectSiteAnnouncementsState,
  (state: SiteAnnouncementsState) => selectEntities(state),
)

export const selectSelectedId = createSelector(
  selectSiteAnnouncementsState,
  (state: SiteAnnouncementsState) => state.selectedId,
)

export const selectEntity = createSelector(selectSiteAnnouncementsEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const selectEditCreateLoaded = createSelector(selectSiteAnnouncementsState, (state) => state.editCreateLoaded)
